import request from '@/utils/request';

let distributionApi = {
  // 分销设置
  getSettingdistribution(data, err) {
    return request._postBody('/shop/AgentGrade/AgentGrade/setting', data, err);
  },
  // 分销设置
  getSettingOnedistribution(data, err) {
    return request._postBody('/shop/AgentGrade/AgentGrade/settingOne', data, err);
  },
  // 激活数量设置
  settingActive(data, err) {
    return request._postBody('/shop/AgentGrade/AgentGrade/settingActive', data, err);
  },

  // 分销设置回显
  getSetting(data, err) {
    return request._get('/shop/AgentGrade/AgentGrade/getSetting', data, err);
  },

  // 分销商等级套餐B等级设置
  getListPlanB(data, err) {
    return request._get('/shop/AgentGrade/AgentGrade/getListPlanB?appId=10001', data, err);
  },
  settingTravelCoupon(data, err) {
    return request._postBody('/shop/AgentGrade/AgentGrade/settingTravelCoupon', data, err);
  },
  // 股东分红设置
  saveShareholder(data, err) {
    return request._postBody('/shop/setting/shareholder/saveShareholder', data, err);
  },

  // 获取股东分红设置
  getShareholder(data, err) {
    return request._get('/shop/setting/shareholder/getShareholder', data, err);
  },
  // 周期奖励设置
  saveActiveNumBack(data, err) {
    return request._postBody('/shop/setting/activeNumBack/saveActiveNumBack', data, err);
  },

  // 获取周期奖励设置
  getActiveNumBack(data, err) {
    return request._get('/shop/setting/activeNumBack/getActiveNumBack', data, err);
  },
  //wifi等级
  getWifiGrade(data,err){
     return request._get('/shop/iot/grade/getList', data, err);
  },
  //保存wifi等级设置
  saveWifiGrade(data, err) {
    return request._postBody('/shop/iot/grade/settingGrade', data, err);
  },

}

export default distributionApi;



// WEBPACK FOOTER //
// ./src/api/plus/distribution.js